module.exports = __webpack_public_path__ + "96675d73a121d867e0cc14222315061a.png";